import ImageUploader from './ImageUploader';
import { Chip, Input } from './Ui';
import { FUEL_TYPES } from '../utils/vertical';

const FOUR_WHEEL = ['cab', 'taxi', 'van'];

/** The vehicle a driver, rider or courier works with - onboarding and profile. */
const VehicleForm = ({ value = {}, onChange, type }) => {
  const v = { brand: '', model: '', number: '', year: '', colour: '', fuelType: '', seats: '', photo: '', ...value };
  const set = (patch) => onChange({ ...v, ...patch });
  const fourWheels = FOUR_WHEEL.includes(type || v.type || 'cab');

  return (
    <div>
      <div className="split-2" style={{ gap: 12 }}>
        <Input label="Company" placeholder={fourWheels ? 'Maruti, Hyundai…' : 'Hero, Honda, TVS…'} value={v.brand} onChange={(e) => set({ brand: e.target.value })} />
        <Input label="Model" placeholder={fourWheels ? 'Dzire, Ertiga…' : 'Splendor, Activa…'} value={v.model} onChange={(e) => set({ model: e.target.value })} />
      </div>
      <div className="split-2" style={{ gap: 12 }}>
        <Input label="Registration number" placeholder="HR02AB1234" value={v.number} onChange={(e) => set({ number: e.target.value.toUpperCase() })} />
        <Input label="Year" inputMode="numeric" placeholder="2021" value={String(v.year || '')} onChange={(e) => set({ year: e.target.value.replace(/\D/g, '').slice(0, 4) })} />
      </div>
      <div className="split-2" style={{ gap: 12 }}>
        <Input label="Colour" placeholder="White" value={v.colour} onChange={(e) => set({ colour: e.target.value })} />
        {fourWheels ? (
          <div>
            <label className="field-label">Seats</label>
            <div className="row wrap" style={{ gap: 8 }}>
              {[4, 5, 7].map((n) => <Chip key={n} label={`${n} seater`} active={Number(v.seats) === n} onClick={() => set({ seats: n })} />)}
            </div>
          </div>
        ) : null}
      </div>
      <label className="field-label">Fuel</label>
      <div className="row wrap" style={{ gap: 8, marginBottom: 12 }}>
        {FUEL_TYPES.map((f) => <Chip key={f} label={f.toUpperCase()} active={v.fuelType === f} onClick={() => set({ fuelType: f })} />)}
      </div>
      <ImageUploader label="Vehicle photo" hint="Customers see this so they can spot you." folder="vehicle" multiple={false} value={v.photo} onChange={(url) => set({ photo: url })} />
    </div>
  );
};

/** One line the customer and admin read: "Maruti Dzire · HR02AB1234 · White · 5 seater". */
export const vehicleLine = (v = {}) => [
  [v.brand, v.model].filter(Boolean).join(' '),
  v.number,
  v.colour,
  v.year,
  v.seats ? `${v.seats} seater` : '',
].filter(Boolean).join(' · ');

export default VehicleForm;
